export class PrimeNgLocaleCalendar {

  constructor (
    public firstDayOfWeek: number,
    public dayNames: string[],
    public dayNamesShort: string[],
    public dayNamesMin: string[],
    public monthNames: string[],
    public monthNamesShort: string[],
    public today: string,
    public clear: string
  ) { }

}



// WEBPACK FOOTER //
// /dist/src/app/shared/primeng-locale/primeng-locale-calendar.model.ts